import { formatCreditNumber, formatCredits } from "../lib/credits.js";
import { useT } from "../lib/i18n/store.js";
import { CreditIcon } from "./CreditIcon.js";

/**
 * The price of a paid action, worn on its button: a coin and the bare number, so
 * the cost is read at the moment of clicking instead of in a hint next to it.
 * Screen readers get the full "(100 credits)" as part of the button's name.
 */
export function CostTag({ credits }: { credits: number }) {
  const t = useT();
  return (
    <span className="cost-tag">
      <CreditIcon size={14} />
      <span aria-hidden="true">{formatCreditNumber(credits)}</span>
      <span className="sr-only"> ({formatCredits(credits, t)})</span>
    </span>
  );
}
